import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Form, ResetOnSuccess, Field, setErrors, FormError } from '../form';

import SignupModalTrigger from '../auth/SignupModalTrigger';
import ActivateModalTrigger from '../billing/ActivateModalTrigger';
import AccountLimitsError from '../billing/AccountLimitsError';

import { first, keys } from 'lodash';

import copyToClipboard from '../../utils/copyToClipboard';


import {
  FormGroup,
  Button,
  Row,
  Col,
  ModalBody,
  ModalFooter
} from 'reactstrap';


import PixelSetsSelect from '../PixelSets/PixelSetsSelect';
import PreloadUniqueSlug from '../Links/PreloadUniqueSlug';
import CustomSlugInputField from '../Links/CustomSlugInputField';

import { urlScraperDecorator } from '../Links/urlScraper';
import setFieldData from 'final-form-set-field-data';

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faChevronRight from '@fortawesome/fontawesome-pro-light/faChevronRight';


import messengersScheme from '../SmartLinks/schemes/messengers';
import SchemedField from '../SmartLinks/SchemedField';


import { getIn } from 'final-form';
import createDecorator from 'final-form-calculate';

import { currentUserSelector } from '../../reducers/selectors'


const mapStateToProps = state => ({ pixelSets: state.pixelSets, currentUser:currentUserSelector(state) });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch)
};

const PixelSetsSelectAdapter = ({input})=>{
  return <PixelSetsSelect selectedIds={input.value} onChange={input.onChange} />
}


const sublinksFieldRegEx = /(settings)\.(\w+)/
export const messengerUrlDecorator = createDecorator(
  {
    field: sublinksFieldRegEx, // when a field matching this pattern changes...
    updates: (itemValue, name, allValues) => {
      const matches = name.match(sublinksFieldRegEx)
      
      if (!matches)
        return {}
      
      // const listKey = matches[2]
      const itemKey = matches[1]
      const item = getIn(allValues, itemKey)//allValues.settings[listKey][idx] 
      
      if (!item)
        return {}
      
      const mutatorFn = (messengersScheme[item.type] || {}).urlMutator
      if (mutatorFn){
        const res = {
          url: item.handle && mutatorFn(item)
        }
        return res
      }
      return {}
    }
  }
)


class MessengerLinkForm extends Component {
  
  constructor (props) {
    super(props);
    
    this.copyOnSubmit = this.copyOnSubmit.bind(this)
    this.toggleCopy = this.toggleCopy.bind(this);
    this.urlScraperDecorator = urlScraperDecorator('url', 'meta');
    
    this.state = {
      tagsInput: false,
      initialValues: this.props.initialValues,
      copy: true
    };
  }
  
  toggleCopy () {
    this.setState({ copy: !this.state.copy })
  }
  
  copyOnSubmit (values){
    if (this.state.copy === false || !(values.slug || values.unique_slug))
      return 
    const shortUrl = "https://shor.by/" + (values.slug || values.unique_slug)
    copyToClipboard(shortUrl)
    // console.log("copy link", "https://shor.by/" + (values.slug || values.unique_slug));
  }
  
  componentWillMount (){
    this.setInitialValues(this.props)
  }
  
  componentWillReceiveProps (nextProps){
    if (this.props.pixelSets !== nextProps.pixelSets)
      this.setInitialValues(nextProps)
  }
  
  setInitialValues (props){
    const defaultPixelSetId = parseInt(first(keys(props.pixelSets)), 10);
    const { initialValues } = this.state// { ...(props.initialValues || {}), ...(this.state.initialValues || {}) }
    
    if ( defaultPixelSetId && (!initialValues || first(initialValues.pixel_set_ids) !== defaultPixelSetId) ){
      this.setState({
        initialValues: {...initialValues, pixel_set_ids: [defaultPixelSetId]}
      });
    }
  }
  
  toggleTags (e) {
    if (e)
      e.preventDefault();
    this.setState({tagsInput: !this.state.tagsInput})
  }
  
  render () {
    const { onSubmit, onSuccess, onFail, resetOnSuccess, catchSubmitEvent, modalWrappers, currentUser } = this.props;
    const { initialValues } = this.state;
    
    const BodyWrapper = modalWrappers === true ? ModalBody : React.Fragment
    const FooterWrapper = modalWrappers === true ? ModalFooter : React.Fragment
    
    const isEdit = !!initialValues.id
    
    const toSignup = !currentUser || !currentUser.id
    
    return (
      <Form
        {...{onSubmit, onSuccess, onFail, resetOnSuccess, initialValues}}
        decorators={[ this.urlScraperDecorator, messengerUrlDecorator ]}
        mutators={{setFieldData, setErrors}}
        render={({ submitError, handleSubmit, submitting, pristine, values, form: {reset} }) => (
          
          <form className="link-form" onSubmit={(event) => {catchSubmitEvent && catchSubmitEvent(event); this.copyOnSubmit(values); handleSubmit(event);} } noValidate={true}>
            
            <BodyWrapper>
              {submitError && !submitError.match(/sign\s+?(up|in)|signature/i) && <FormError>{submitError}</FormError>}
              
              <SignupModalTrigger initialValues={{ref: 'messenger'}} onSuccess={() => handleSubmit(values)} />
              <ActivateModalTrigger />
              <AccountLimitsError />
              
              <Row>
                <Col sm={12} md={7} className="form-group">
                  <SchemedField {...{name: 'settings', scheme: messengersScheme, fieldValue: (values.settings || {}), submitting}} />
                </Col>
                <Col className="shorten-arrow d-none d-md-block">
                  <FA icon={faChevronRight} />
                </Col>
                <Col sm={12} md={5} className="form-group">
                  <PreloadUniqueSlug />
                  <CustomSlugInputField submitting={submitting} values={values} />
                </Col>
              </Row>
              
              <FormGroup>
                <span className="small">Tracking Pixels:</span>  <Field 
                  name="pixel_set_ids"
                  component={PixelSetsSelectAdapter}
                />
              </FormGroup>
              
              {false && <pre>{JSON.stringify(values, 0, 2)}</pre>}
              
              <ResetOnSuccess enabled={resetOnSuccess || false} reset={reset} />
            </BodyWrapper>
            
            <FooterWrapper>
              {(values.unique_slug || values.slug) && (
                <label className="small">copy to clipboard  
                  <input type="checkbox" checked={this.state.copy} onChange={this.toggleCopy} />
                </label>)}
              
              <div className="text-right">
                <Button
                  color="primary"
                  type="submit"
                  className="btn-wide upcase"
                  disabled={submitting}
                  onSubmit={this.copyOnSubmit}>
                  {isEdit ? 'Save' : (toSignup ? 'Signup & Create': 'Create')}
                </Button>
              </div>
            </FooterWrapper>
            
          </form>
        )}
      />
    )
  };
}

export default connect(mapStateToProps, matchDispatchToProps)(MessengerLinkForm);


// WEBPACK FOOTER //
// ./src/components/MessengerLinks/form.js